
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

interface ServiceHighlightProps {
  title: string;
  items: string[];
}

const ServiceHighlight = ({ title, items }: ServiceHighlightProps) => {
  return (
    <div>
      <h4 className="text-xl font-semibold mb-4">{title}</h4>
      <ul className="space-y-3">
        {items.map((item, itemIndex) => (
          <li key={itemIndex} className="flex items-start">
            <CheckCircle className="w-5 h-5 text-emerald-200 mr-3 mt-1 flex-shrink-0" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceHighlight;
